import { render, staticRenderFns } from "./ProductModifier.vue?vue&type=template&id=50c2bcb8&scoped=true"
import script from "./ProductModifier.vue?vue&type=script&lang=js"
export * from "./ProductModifier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50c2bcb8",
  null
  
)

export default component.exports